import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function howWorkCards() {
  const swiper = new Swiper('.how-work-cards__swiper', {
    modules: [Pagination],
    spaceBetween: 16,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        enabled: false,
      },
    },
  });
}
